import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import Dashboards from '../../../../libs/api/services/Dashboards'

const DashboardContext = React.createContext()
var Queue = []
export const DashboardProvider = ({ children }) => {
    const [loading, setLoading] = useState(true)
    // const [_tmr0, setTMR0] = useState()
    const [results, setResults] = useState({
        Messages: undefined,
        Alerts: undefined
    })

    const [filters, setFilters] = useState({
        Messages: {
            Status: 'All'
        },
        Alerts: undefined
    })

    const LoadData = async (request) => setResults(await Dashboards.All(request))

    // const ProcessQueue = async (resolve) => {
    //     while (true) {
    //         if (Queue.length > 0) {
    //             if (window.location.pathname !== '/Dashboard')
    //                 Queue = []
    //             var lastRes = []
    //             for (var q of Queue)
    //                 try {
    //                     lastRes = await Dashboards.All(Queue.shift().request)
    //                     console.log('Received dashboard update (' + Queue.length + ' - ' + _tmr0 + ') ' + window.location.pathname + ' : ', JSON.stringify(q), lastRes)

    //                 } catch (e) {
    //                     console.error('Failed to update database : ', e)
    //                 }
    //             setResults(lastRes)
    //         }

    //         if (Queue.length > 1)
    //             Queue = [Queue[Queue.length - 1]]

    //         await new Promise(r => setTimeout(r, 100));
    //     }
    // }


    const AddToQueue = async (request) => {
        const _request = JSON.parse((JSON.stringify(request)))
        Queue.push({
            request: _request,
            status: 'waiting'
        })
        // ProcessQueue()
    }

    const load = async (filtersState) => {
        setLoading(true)
        AddToQueue(filtersState)
        setLoading(false)
    }

    useEffect(() => {
        LoadData(filters)
        // const load = async () => await
        //     // new Promise(resolve => {
        //     //     ProcessQueue(resolve)
        //     // });
        // AddToQueue(filters)
        // load()
        return () => { Queue = [] }
    }, [filters])

    useEffect(() => {
        // if (_tmr0) clearInterval(_tmr0)
        load(filters)
        // setTMR0(setInterval(async () => { await load(filters) }, 1000 * 60))
        // return () => { _tmr0 && clearInterval(_tmr0) }
    }, [filters])
    return (
        <DashboardContext.Provider value={{
            results,
            setFilter: (module, key, value) =>
                setFilters({ ...filters, [module]: { ...filters[module], [key]: value } }),
            // setFilters,
            filters,
            filter: (module, key) => filters[module][key],
            test: () => console.log('Test context', results),
            Queue
        }}>
            {loading && <div style={{
                position: 'fixed',
                bottom: '0px',
                right: '0px',
            }} className='bg-light rounded shadow p-1'><FontAwesomeIcon icon={faSpinner} spin /> Updating your dashboard</div>}
            {children}
        </DashboardContext.Provider>
    )
}

export default DashboardContext